<template>
  <div ref="ueditorWrap">
    <vue-ueditor-wrap
      class="vue-ueditor-wrap"
      :destroy="true"
      @ready="ready"
      id="myeditor"
      mode="listener"
      v-model="msg.innerHTML"
      :config="editorConfig"
      ref="editor"
      @beforeInit="addCustomButtom"
    ></vue-ueditor-wrap>
    <el-dialog title="上传图片" :visible.sync="dialogVisible" :modal="false">
      <el-upload
        class="upload-demo"
        drag
        accept=".png, .jpg"
        :headers="header"
        :action="uploadUrl"
        :before-upload="beforeUpload"
        :on-success="uploadImageSuccess"
        :on-error="uploadImageError"
      >
        <i class="el-icon-upload" />
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div slot="tip" class="el-upload__tip">
          只能上传jpg/png文件，且不超过5M
        </div>
      </el-upload>
    </el-dialog>
  </div>
</template>

<script>
const TAG_NAME_TABLE = "TABLE";
const MARGIN_BOTTOM = 10;
import VueUeditorWrap from "vue-ueditor-wrap";
import {
  UEDITOR_CONFIG,
  UEDITOR_CONFIG_BLANK,
  UEDITOR_CONFIG_BLANK_SCORE,
  UEDITOR_CONFIG_ANSWER,
  TAG_P_HEIGHT,
  PADDING_TOP,
  KONGGE_ELEMENT,
  KONGGE_ELEMENT_UNDERLINE,
  WHITE_SPACE_NBSP,
  WHITE_SPACE_NONBSP,
  STATE_KEY
} from "@/subjects/constant";





import { PADDING_SIDES } from "@/utils/html2pdf/html2canvas";
import MyDragImage from "../../../assets/js/utils/base/MyDragImage";
import MyDragImageLimit from "../../../assets/js/utils/base/MyDragImageLimit";
export default {
  props: ["msg"],
  components: {
    VueUeditorWrap,
  },
  data() {
    return {
      myVal: "<span></span>",
      toolbarClicked: false,
      imageClicked: false,
      editorClicked: false,
      editorInstance: undefined,
      mouseLeaveSignal: false,
      focusSignal: true,
      realHeightAfterEdit: 0,
      cacheContent: "",
      // 编辑器点击（获取焦点）时的html内容
      editorHtmlBeforeClicked: "",
      editorTagType: ["p", "table", "image"],
      header: {
        // "content-type": "application/form-data",注释掉
        token: localStorage.getItem(STATE_KEY.APP_TOKEN_KEY),
      },
      uploadUrl: "/dtk/image/upload",
      dialogVisible: false,
      key: "",
    };
  },
  computed: {
    editorConfig() {
      const CONFIG =
        this.msg.type == 1
          ? this.msg.eachBlankScore
            ? UEDITOR_CONFIG_BLANK_SCORE
            : UEDITOR_CONFIG_BLANK
          : this.msg.type == 3 || this.msg.type == 4 || this.msg.type == 6
          ? UEDITOR_CONFIG_ANSWER
          : UEDITOR_CONFIG;

      CONFIG.imagePostParams = {
        // 在这里添加你需要携带的参数
        token: localStorage.getItem(STATE_KEY.APP_TOKEN_KEY),
      };
      // CONFIG.imagePaste = true;
      console.log("editorConfig======", CONFIG);

      return this.$store.state.answerPanel.answerSheet.acCardHideScore
        ? {
            ...CONFIG,
            initialStyle: `p{line-height:${TAG_P_HEIGHT}px;} .row span.score {display: none;}`,
          }
        : {
          ...CONFIG,
        };
    },
  },
  methods: {
    /**
     * @description: 上传图片
     * @param {*}
     * @return {*}
     */
    addCustomButtom() {
      const that = this;
      window.UE.registerUI("simpleupload", function (editor, uiName) {
        // 注册按钮执行时的 command 命令，使用命令默认就会带有回退操作
        editor.registerCommand(uiName, {
          execCommand: function () {
            editor.execCommand("inserthtml", ``);
          },
        });
        // 参考http://ueditor.baidu.com/doc/#COMMAND.LIST
        var btn = new window.UE.ui.Button({
          name: uiName,
          title: "上传图片",
          // cssRules: `background-position: -380px 0px;`,
          onclick: function (e) {
            editor.execCommand(uiName);
            // 渲染dialog
            that.dialogVisible = true;
            // 插入图片时, 由于blur事件监听 和 光标位置强制在末尾的原因，暂时使用缓存强制设置图片插入的位置
            localStorage.setItem("IMG.UE.KEY", editor.key);
          },
        });

        return btn;
      });
    },
    beforeUpload(file) {
      const types = ["image/jpeg", "image/gif", "image/bmp", "image/png"];
      const isImage = types.includes(file.type);
      const isLtSize = file.size / 1024 / 1024;
      if (isImage && isLtSize > 5) {
        this.$message.warning("上传图片大小不能超过 5MB!");
        return false;
      }
      if (file.size > 1024 * 1024 * 300) {
        this.$message.warning("文件大小不能够超过 300MB!");
        return false;
      }
      return true;
    },
    /**
     * @description: 上传图片
     * @param {*}
     * @return {*}
     */
    // eslint-disable-next-line no-unused-vars
    uploadImageSuccess(response, file, fileList) {
      if (response && response.errno == 0) {
        this.$message({
          message: "上传成功",
          type: "success",
        });
        const fileObj = {
          url: response.data.url,
        };
        this.uploadFile(fileObj);
      } else {
        this.$message({
          message: "上传失败",
          type: "warning",
        });
      }
    },
    /**
     * @description: 将图片插入到富文本中
     * @param {*} file
     * @return {*}
     */
    uploadFile(file) {
      let editorKey = localStorage.getItem("IMG.UE.KEY");
      // 关键
      window.UE.getEditor(editorKey).execCommand("insertimage", {
        src: file.url,
        // width: '100',
        // height: '100',
      });
      this.dialogVisible = false;
    },
    uploadImageError(res) {
      console.log("uploadImageError=====>", res);
    },
    showToolbarWhenFocus(editorInstance, toolbar) {
      editorInstance.addListener("focus", (editor) => {
        toolbar && (toolbar.style.display = "block");
      });
    },
    handlerToolbarMouseEnter(toolbar) {
      toolbar.onmouseenter = () => {
        this.toolbarClicked = true;
        this.$emit("onMouseEnter");
      };
      toolbar.onmouseleave = () => {
        this.toolbarClicked = false;
      };
    },
    handlerEditorMouseDown(editorInstance) {
      editorInstance.addListener("mousedown", (editor, evt) => {
        if (evt.target.tagName == "IMG") {
          this.imageClicked = true;
          evt.preventDefault();
          // const dragImage = new MyDragImage(evt);
          const dragImageLimit = new MyDragImageLimit(evt);
          dragImageLimit.setMaxHeight(this.msg.initDragHeight);
          if (this.$store.state.answerPanel.answerSheet.acCardPanes == 3) {
            dragImageLimit.setMaxWidth(505);
          } else {
            dragImageLimit.setMaxWidth(706);
          }
          // 和下面的mouseup触发失焦 操作一样 后期代码可以优化下
          this.$refs.ueditorWrap.onmouseleave = (e) => {
            if (this.imageClicked) {
              console.log("离开图片", this.msg);
              let mycontent = editorInstance.getContent();
              // let mycontent = this.contrastDifferentEditorContent(editorInstance.getContent(), evt);
              if (mycontent.split(KONGGE_ELEMENT).length > 1)
                mycontent = this.appendKONGGEToSPAN(
                  mycontent && mycontent.split(KONGGE_ELEMENT),
                  KONGGE_ELEMENT
                );
              mycontent &&
                this.$emit("onBlur", {
                  editorHeight: this.msg.initDragHeight,
                  content: mycontent,
                  isEnterKeyUp: this.isEnterKeyUp,
                  overstepDistance: 0,
                });
              this.toolbarClicked = false;
              this.$refs.ueditorWrap.onmouseleave = null;
            }
          };
          // this.$refs.ueditorWrap.addListener("mouseleave", (e) => {

          // });
        }
      });
    },
    handlerEditorMouseUp(editorInstance) {
      editorInstance.addListener("mouseup", (editor, evt) => {
        if (evt.target.tagName == "IMG") {
          let mycontent = editorInstance.getContent();
          if (mycontent.split(KONGGE_ELEMENT).length > 1)
            mycontent = this.appendKONGGEToSPAN(
              mycontent && mycontent.split(KONGGE_ELEMENT),
              KONGGE_ELEMENT
            );
          mycontent &&
            this.$emit("onBlur", {
              editorHeight: this.msg.initDragHeight,
              content: mycontent,
              isEnterKeyUp: this.isEnterKeyUp,
              overstepDistance: 0,
            });
          this.toolbarClicked = false;
        } else {
          // this.toolbarClicked = true;
        }
        document.onmousemove = null;
        this.$emit("onMouseDown");
        // const timer = setTimeout(() => {
        //   this.focusSignal && editorInstance.focus(true); // 光标强制到末尾
        //   this.focusSignal = false;
        //   clearTimeout(timer);
        // }, 80);
      });
    },
    /**
     *  对比编辑器失焦前后的content内容（对比字符串）是否相同
     * 相同 则失焦不去更改保存信息 反之保存
     * @param {string} content 失焦传进来的html内容
     */
    contrastDifferentEditorContent(content, evt) {
      // 获取编辑器真实dom的html内容
      const mybody = evt.target.frameElement.contentWindow.document.body;
      this.cacheContent = mybody.innerHTML;
      console.log(
        this.cacheContent,
        "------",
        this.editorHtmlBeforeClicked,
        "editorHtmlBeforeClicked"
      );
      return this.cacheContent;
    },
    handlerEditorBlur(editorInstance, toolbar) {
      let timer = undefined;
      editorInstance.addListener("blur", (editor, evt) => {
        // const content = editorInstance.getContent();
        this.cacheContent = editorInstance.getContent();
        // this.blankEditorBlur(evt);
        // timer = setTimeout(() => {
        let editorHeight = 0;
        // 获取dom实时hmtl
        this.cacheContent = this.contrastDifferentEditorContent(
          editorInstance.getContent(),
          evt
        );
        if (this.toolbarClicked || this.imageClicked) {
          this.imageClicked = false;
          return;
        } else {
          toolbar && (toolbar.style.display = "none");
        }
        this.realHeightAfterEdit =
          this.getRealHeightAfterEdit(evt) + PADDING_TOP; // 因为编辑器内部有个向上的内边距高度 需要加上
        editorHeight =
          this.realHeightAfterEdit < this.msg.initDragHeight
            ? this.msg.initDragHeight
            : this.realHeightAfterEdit + MARGIN_BOTTOM;
        let mycontent = this.cacheContent;
        if (mycontent.split(KONGGE_ELEMENT).length > 1)
          mycontent = this.appendKONGGEToSPAN(
            mycontent && mycontent.split(KONGGE_ELEMENT),
            KONGGE_ELEMENT
          );
        mycontent &&
          this.$emit("onBlur", {
            editorHeight: editorHeight,
            content: mycontent,
            isEnterKeyUp: this.isEnterKeyUp,
            overstepDistance: editorHeight - this.msg.initDragHeight,
          });
        this.toolbarClicked = false;
        this.mouseLeaveSignal = false;
      });
    },
    handlerEditorFocus(editorInstance) {
      editorInstance.addListener("focus", (editor, evt) => {
        // 获取编辑器真实dom的html内容
        const mybody = evt.target.frameElement.contentWindow.document.body;
        this.editorHtmlBeforeClicked = mybody.innerHTML;
        this.editorInstance = editorInstance;
      });
    },
    /**
     * 监听编辑器里面的键盘事件（这里为了监听删除图片的回车键 将图片imageclicked字段置为false）
     */
    handlerEditorKeydowm(editorInstance) {
      editorInstance.addListener("keydown", (editor, evt) => {
        this.imageClicked && (this.imageClicked = false);
      });
    },
    appendKONGGEToSPAN(target, str) {
      if (target) {
        return target
          .map((item, index) => {
            const istrue = item.indexOf("&#8203") != -1;
            // const hasWHITE_SPACE = item.indexOf('<span style="white-space: normal;">&nbsp; &nbsp') != -1;
            // const hasWHITE_SPACE_NONBSP = item.indexOf('<span style="white-space: normal;">') != -1;
            // const prevHAS_TEXT_UNDELINE = target[index-1] && target[index-1].indexOf('<span style="text-decoration: underline;">') != -1;
            // const prevHAS_SPACE = target[index-1] && target[index-1].indexOf('<span style="white-space: normal;">') != -1;
            // const prevHAS_SPACE_BOTH = target[index-1] && target[index-1].indexOf('<<span style="white-space: normal; text-decoration-line: underline;">') != -1;
            // if(hasWHITE_SPACE) {
            //  item = item.replace(/<span style="white-space: normal;">&nbsp; &nbsp+/g, WHITE_SPACE_NBSP);
            // } else if( (hasWHITE_SPACE_NONBSP && prevHAS_TEXT_UNDELINE) || prevHAS_SPACE || prevHAS_SPACE_BOTH) {
            //  item = item.replace(/<span style="white-space: normal;">+/g, WHITE_SPACE_NONBSP);
            // }
            // return index == target.length-1 ? item : `${item}&#8203;` ;
            return item.indexOf("&#8203") != -1
              ? item
              : item.replace(/&nbsp+/g, "&nbsp;&#8203");
          })
          .join(str);
      } else {
        return target || "";
      }
    },
    blankEditorBlur(evt) {
      if (this.msg.type == 1) {
        try {
          const mybody = evt.target.frameElement.contentWindow.document.body;
          this.cacheContent = mybody.innerHTML;
        } catch (e) {
          console.error("获取填空题dom出错", e.message);
        }
      }
    },
    ready(editorInstance) {
      // vue模板更新视图的时候会导致编辑器初始化，初始化导致焦点回到原点 这里焦点强制到末尾
      // 编辑器的问题大部分都集中在这里的监听事件
      if(editorInstance){
          editorInstance.autoHeightEnabled = true;
        this.editorInstance = editorInstance;

        const myeditor = document.getElementById(editorInstance.key);
        const toolbar = myeditor.querySelector(".edui-editor-toolbarbox");
        this.showToolbarWhenFocus(editorInstance, toolbar);
        this.handlerToolbarMouseEnter(toolbar);
        toolbar.onclick = () => {
          this.toolbarClicked = true;
        };
        this.handlerEditorMouseDown(editorInstance);
        this.handlerEditorMouseUp(editorInstance);
        // toolbar.onmouseleave = () => {
        //   this.toolbarClicked = false;
        // };
        // editorInstance.addListener("onchange", (editor) => {
        //   console.log(editor, "-------------");
        // });
        this.handlerEditorBlur(editorInstance, toolbar);
        this.handlerEditorFocus(editorInstance);
        this.handlerEditorKeydowm(editorInstance);
        if (this.msg.type == 6) {
          this.editorInstance &&
            this.editorInstance.setHeight(this.msg.initDragHeight - 38);
        } else {
          this.editorInstance &&
            this.editorInstance.setHeight(this.msg.initDragHeight);
        }
      }
      
    },
    /**
     * 获取编辑器编辑之后的高度
     */
    getRealHeightAfterEdit(evt) {
      let realHeightAfterEdit = 0;
      let realHTML = "";
      try {
        const elements =
          evt.target.frameElement.contentWindow.document.body.childNodes;
        Array.from(elements).forEach((el) => {
          if (el.tagName == TAG_NAME_TABLE) {
            realHeightAfterEdit += el.offsetHeight + MARGIN_BOTTOM || 0;
          } else {
            realHeightAfterEdit +=
              el.offsetHeight || (el.tagName ? 0 : TAG_P_HEIGHT); // 如果在表格后面直接输入文字，编辑器会自动换行 然后直接失焦操作的话el.tagName是undefined的，其实是存在生成的p 所以高度得加上
          }
          this.findStyleTextUnderline(el, false);
          realHTML += el.outerHTML || "";
        });
        // !this.cacheContent &&( this.cacheContent = realHTML );
        this.cacheContent = realHTML;
        return realHeightAfterEdit;
      } catch (e) {
        console.error("获取编辑器下面所有元素报错", e.message);
      }
    },
    /**
     * 递归查找子元素的style 是否有unline属性
     */
    findStyleTextUnderline(el, hasTextUnderline) {
      if (el.children) {
        Array.from(el.children).forEach((elChildrenItem) => {
          const styleStr = elChildrenItem.getAttribute("style");
          const isNotSpanTag = elChildrenItem.tagName != "SPAN"; // 直接在编辑器输入文字的话 会显示无标签或者a标签内容 是不需要set下划线样式的
          if (styleStr) {
            if (styleStr.indexOf("text-decoration: underline") != -1) {
              hasTextUnderline = true;
            } else {
              hasTextUnderline &&
                !isNotSpanTag &&
                styleStr.indexOf("white-space") != -1 &&
                elChildrenItem.setAttribute(
                  "style",
                  styleStr + ";text-decoration: underline"
                );
            }
          }
          el.children.length &&
            this.findStyleTextUnderline(elChildrenItem, hasTextUnderline);
        });
      }
    },
    setToolBarClicked(toolbarClicked) {
      const wrapList = document.querySelectorAll(".vue-ueditor-wrap");

      // this.$refs.ueditorWrap.addListener("mouseleave", (e) => {

      // });
      this.$refs.ueditorWrap.onmouseleave = (e) => {
        this.toolbarClicked = false;
        this.mouseLeaveSignal = true;
      };
    },
    /**
     * 用来更新下划线保存的时候没有&#8203;导致下划线下载pdf不显示问题
     */
    insertSpaceIntoContent(content) {
      // try {
      //   const FIX_SYMBOL = "&#8203;"; // 填充符
      //   const SPLIT_SYMBOL = '<span style="text-decoration: underline;">';
      //   if (content && content.indexOf(SPLIT_SYMBOL) != -1) {
      //     let strArr = content.split(SPLIT_SYMBOL);
      //     strArr = strArr.map((str, index) => {
      //       if (index == 0) {
      //         return str;
      //       } else {
      //         return SPLIT_SYMBOL + FIX_SYMBOL + str;
      //       }
      //     });
      //     return strArr.join("");
      //   } else {
      //     return content;
      //   }
      // } catch (e) {
      //   console.error("处理下划线不显示问题报错", e.message);
      // }
    },
    handlerSaveClick() {
      document.querySelector(".submit-text").onclick = () => {
        let editorHeight =
          this.realHeightAfterEdit < this.msg.initDragHeight
            ? this.msg.initDragHeight
            : this.realHeightAfterEdit + MARGIN_BOTTOM;
        this.$emit("onBlur", {
          editorHeight: editorHeight,
          content: this.cacheContent,
          isEnterKeyUp: this.isEnterKeyUp,
          overstepDistance: editorHeight - this.msg.initDragHeight,
        });
        // const timer = setTimeout(() => {
        //   sessionStorage.clear();
        //   clearTimeout(timer);
        // }, 2000);
        this.toolbarClicked = false;
      };
    },
  },
  watch: {
    "msg.initDragHeight": {
      //handler:'test',
      handler(height) {
        if (this.msg.type == 6) {
          this.editorInstance && this.editorInstance.setHeight(height - 38);
        } else {
          this.editorInstance && this.editorInstance.setHeight(height);
        }
      },
    },
    msg: {
      handler(msg) {
        this.editorInstance &&
          this.editorInstance.setContent(msg.innerHTML || "");
      },
      deep: true,
    },
  },
  // destroyed() {
  //   this.editorInstance && this.editorInstance.destroy();
  // },
  mounted() {
    this.setToolBarClicked(false);
  },
};
</script>

<style>
.edui-default .edui-editor {
  border: none !important;
}
</style>
